import { render, staticRenderFns } from "./_button.vue?vue&type=template&id=6a22cbbb&scoped=true&"
import script from "./_button.vue?vue&type=script&lang=js&"
export * from "./_button.vue?vue&type=script&lang=js&"
import style0 from "./_button.vue?vue&type=style&index=0&id=6a22cbbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a22cbbb",
  null
  
)

export default component.exports